export default __webpack_public_path__ + "static/media/ibmbanner.ef81f056.png";